import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Trophy } from "lucide-react";
import { championships } from "../data/matches";
import { ChampionshipCard } from "./ChampionshipCard";

const SCROLL_STEP_PX = 640;
const NAV_BTN = "w-9 h-9 rounded-full bg-white/5 hover:bg-yellow-500/30 transition border border-white/10 flex items-center justify-center";

const SectionTitle = () => (
  <div className="flex items-start gap-3">
    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-600 flex items-center justify-center shadow-lg shadow-orange-600/30">
      <Trophy className="w-6 h-6 text-white" />
    </div>
    <div>
      <div className="flex items-center gap-2 text-[11px] text-yellow-400/80 font-bold uppercase tracking-widest mb-1">
        <span className="inline-flex items-center gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-light animate-pulse" />
          Todos os campeonatos
        </span>
        <span className="text-white/30">•</span>
        <span className="text-white/60">Assista em Full HD</span>
      </div>
      <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight">Principais Campeonatos de Futebol</h2>
      <p className="text-white/60 text-sm mt-1 max-w-2xl">
        Do Brasileirão à Champions League: cobertura completa dos maiores torneios do futebol mundial.
      </p>
    </div>
  </div>
);

export default function FeaturedMatches() {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * SCROLL_STEP_PX, behavior: "smooth" });

  return (
    <section data-testid="featured-championships" className="max-w-[1500px] mx-auto px-6 mt-16">
      <div className="flex items-end justify-between mb-4">
        <SectionTitle />
        <div className="hidden md:flex gap-2">
          <button onClick={() => scroll(-1)} className={NAV_BTN} aria-label="Anterior">
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button onClick={() => scroll(1)} className={NAV_BTN} aria-label="Próximo">
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>

      <div ref={ref} className="no-scrollbar flex gap-4 overflow-x-auto pb-4 -mx-2 px-2 snap-x">
        {championships.map((c) => <ChampionshipCard key={c.id} c={c} />)}
      </div>
    </section>
  );
}
